export default "__VITE_ASSET__DKLn3YAf__"